"use client"

import React, { Component } from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import routes from "../../routes/URL";
import API, { URL_PATH } from "../../services/API";
import redux from "../../common/Redux";
import Table from "../../components/Table";
import Switch from "../../components/Switch";
import { getCurrency } from "../../common/util";
import Toast from "../../components/Toast";
import ConfirmationModal from "../../components/ConfirmationModal";
import Header from "../../components/Header"
import CardHeader from "@mui/material/CardHeader";
import vegIcon from "../../assets/veg.svg";
import nonVegIcon from "../../assets/nonveg.svg";
import egg from "../../assets/Egg.png"
import Drinks from "../../assets/Drinks.png"

const ColorScheme = {
  buttonColor: "#FFC857",
  bgColor: "#02111B",
  componentColor: "#07070A",
  accentColor: "#BB0A21",
  textColor: "#FFFFFF",
};

class DetailScreen extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      data: [], 
      category_name: "", 
      category_image: "",
      version: 0,
      selectedRows: [],
      isBulkDeleteConfirmationModalOpen: false,
      toast: {
        open: false,
        message: "",
        severity: "success",
      },
    };
  }

  componentDidMount() {
      const hotel = this.props.hotels.find(h => h.hotel_slug === this.props.match.params.hotelSlug);
    if (!hotel) {
        this.props.history.push(routes.admin.dashboard.root(this.props.hotels[0]?.hotel_slug || ''));
        return;
    }
    const category_id = this.props.match.params.id;
    this.fetchData(category_id);
  }

  fetchData = async (category_id) => {
    const { status, message, data } = await API(
      this,
      "get",
      URL_PATH.catagoryDetails(category_id)
    );

    if (status == "success") {
      if (data.slug !== this.props.match.params.slug) {
    this.props.history.push(routes.admin.dashboard.root(this.props.hotels[0]?.hotel_slug || ''));
    return;
      }
      this.setState({
        category_name: data.category_name,
        category_image: data.category_image,
        category_status: data.status,
      });
    }
  };

  showToast = (message, severity) => {
    this.setState({
      toast: {
        open: true,
        message,
        severity,
      },
    });
  };

  handleCloseToast = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({
      toast: {
        ...this.state.toast,
        open: false,
      },
    });
  };

  onCategoryDelete = async (id) => {
    const { status, message, data } = await API(
      this,
      "post",
      URL_PATH.deleteCategory(id)
    );
    if (status == "success") {
      this.showToast(message, "success");
      this.props.history.push(routes.admin.category.root);
    } else {
      this.showToast(message || "Failed to delete category", "error");
    }
  };

  onDelete = async (item) => {
    const { status, message, data } = await API(
      this,
      "post",
      URL_PATH.deleteMenu(item.id)
    );
    if (status == "success") {
      this.showToast(message, "success");
      this.setState({
        version: this.state.version + Math.random() + "",
      });
    } else {
      this.showToast(message || "Failed to delete menu item", "error");
    }
  };

  onEdit = async (item) => {
    this.props.history.push(routes.admin.menu.update( this.props.hotels[0].hotel_slug,item.menu_slug, item.category_slug,item.id, ));
  };

  onSwitch = async (item, value) => {
    const { status, message, data } = await API(
      this,
      "get",
      URL_PATH.updateMenuStatus,
      { menu_id: item.id, status: value }
    );
    if (status !== "success") {
      this.showToast(message || "Failed to update status", "error");
    }
  };

  // Handle selected rows change from Table component
  handleSelectedRowsChange = (selectedRows) => {
    this.setState({ selectedRows });
  };

  // Open bulk delete confirmation modal
  openBulkDeleteConfirmationModal = () => {
    this.setState({ isBulkDeleteConfirmationModalOpen: true });
  };

  // Close bulk delete confirmation modal
  closeBulkDeleteConfirmationModal = () => {
    this.setState({ isBulkDeleteConfirmationModalOpen: false });
  };

  // Handle bulk delete confirmation
  handleBulkDeleteConfirmation = async () => {
    await this.onBulkAction(this.state.selectedRows);
    this.closeBulkDeleteConfirmationModal();
  };

  // Bulk delete action
  onBulkAction = async (rows) => {
    const ids = Object.values(rows);
    const { status, message, data } = await API(
      this,
      "post", 
      URL_PATH.deleteBulkMenu(this.props.selectedHotelId.id),
      { ids }
    );
    if (status) {
      this.showToast(message, "success");
      this.setState({
        version: this.state.version + Math.random() + "",
        selectedRows: [],
      });
    } else {
      this.showToast(message || "Failed to delete items", "error");
    }
  };

  render() {
    const { selectedRows, isBulkDeleteConfirmationModalOpen } = this.state;

    return (
      <div className="container-fluid">
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            alignContent: "center",
            marginBottom: "20px",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-start",
              alignItems: "center",
              alignContent: "center",
            }}
          >
            <CardHeader
                      title={
                        <Header  />
          
                      }
                      sx={{ pb: 2,pr:0 }}
                    />
            <img
              src={this.state.category_image}
              width="70"
              height="70"
              style={{ borderRadius: "5px", marginRight: "10px" }}
            />
            <h1>Category - {this.state.category_name}</h1>
          </div>

            

          {/* <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              alignContent: "center",
              gap: "10px",
            }}
          >
            {selectedRows.length > 0 && (
              <button
                className="btn mr-2"
                style={{
                  backgroundColor: ColorScheme.accentColor,
                  color: ColorScheme.textColor,
                  marginRight: "10px",
                }}
                onClick={this.openBulkDeleteConfirmationModal}
              >
                <i className="fa fa-trash mr-1" aria-hidden="true"></i> Delete Selected ({selectedRows.length})
              </button>
            )}

            {this.state.category_name && (
              <Switch
                checked={this.state.category_status}
                onChange={(val) => {
                  this.setState({ category_status: val });
                  API(this, "get", URL_PATH.updateCategoryStatus, {
                    category_id: this.props.match.params.id,
                    status: val,
                  });
                }}
              />
            )}

            <div
              style={{backgroundColor: "#FFC857",color:"black", padding:"6px", borderRadius:"6px"}}
              onClick={() => {
                this.props.history.push(
                  routes.admin.category.update(this.props.match.params.id)
                );
              }}
            >
              <i className="fa fa-pencil"></i> Edit
            </div>

            <div
           
              style={{backgroundColor: "#BB0A21", padding:"6px", borderRadius:"6px"}}
              onClick={() => {
                this.onCategoryDelete(this.props.match.params.id);
              }}
            >
              <i className="fa fa-trash"></i> Delete
            </div>
          </div> */}
        </div>

        <Table
          key={this.state.version}
          api={URL_PATH.menuByCategoryId(this.props.match.params.id)}
          onRowClick={this.onView}
          onEdit={this.onEdit}
          deleteText="delete all data related to this table."
          onDelete={this.onDelete}
          onSelectedRowsChange={this.handleSelectedRowsChange}
          row={[
            {
              title: "Icon",
              key: "menu_image",
              sortable: false,
              type: "icon",
            },
            {
              title: "Name",
              key: "menu_name",
              sortable: true,
            },
            {
              title: "Type",
              key: "menu_type",
              sortable: true,
              parse: (item) => {
                const type = item.menu_type.toLowerCase();
                let displayText = '';
                let icon = null;
                if (type.includes('nonveg')) {
                  displayText = 'NON-VEG';
                  icon = <img src={nonVegIcon} alt="Non-Veg" style={{ width: "20px", marginRight: "8px" }} />;
                } else if (type.includes('veg')) {
                  displayText = 'VEG';
                  icon = <img src={vegIcon} alt="Veg" style={{ width: "20px", marginRight: "8px" }} />;
                } else if (type.includes('egg')) {
                  displayText = 'EGG FOOD';
                  icon = <img src={egg} alt="egg" style={{ width: "20px", marginRight: "8px" }} />;
                }else if (type.includes('drinks')) {
                  displayText = 'DRINKS';
                  icon = <img src={Drinks} alt="Drinks" style={{ width: "20px", marginRight: "8px" }} />;
                }
                
                else {
                  displayText = type.split(' ').map(word =>
                    word.charAt(0).toUpperCase() + word.slice(1).toUpperCase()
                  ).join(' ');
                }

                return (
                  <div style={{ display: "flex", alignItems: "center" }}>
                    {icon}
                    {displayText}
                  </div>
                );
              },
            },
            {
              title: "Price",
              key: "menu_price",
              sortable: true,
              parse: (item) => {
                return `${getCurrency(this.props.selectedHotelId.currency)} ${item.menu_price}`;
              },
            },
            {
              title: "Available",
              key: "status",
              sortable: true,
              type: "switch",
              onSwitch: this.onSwitch,
            },
          ]}
        />

        {/* Bulk Delete Confirmation Modal */}
        <ConfirmationModal
          isOpen={isBulkDeleteConfirmationModalOpen}
          onConfirm={this.handleBulkDeleteConfirmation}
          onCancel={this.closeBulkDeleteConfirmationModal}
          title="Confirm Bulk Deletion"
          message={`Are you sure you want to delete the selected ${selectedRows.length} items?`}
          confirmText="Yes, delete them!"
          cancelText="Cancel"
        />

        <Toast
          open={this.state.toast.open}
          message={this.state.toast.message}
          severity={this.state.toast.severity}
          handleClose={this.handleCloseToast}
        />
      </div>
    );
  }
}

export default redux(DetailScreen);